import Style from "./EditUserStyle";
import Spinner from "../../shared/Spinner/Spinner";
import api from "../../services/api";

import { useEffect, useState } from "react";
import InfoModal from "../../shared/Bootstrap/InfoModal";
import { CPFMask } from "../../utils";
import PageTitle from "../../components/PageTitle";

export default function EditUser(props) {
  const [loading, setLoading] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");

  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [phone, setPhone] = useState("");
  const [cpf, setCPF] = useState("");
  const [rg, setRG] = useState("");
  const [address, setAddress] = useState("");
  const [cep, setCep] = useState("");
  const [addressNumber, setAddressNumber] = useState("");
  const [city, setCity] = useState("");
  const [state, setState] = useState("");
  const [neighborhood, setNeighborhood] = useState(""); // Novo campo para bairro

  const [showSuccessPopup, setShowSuccessPopup] = useState(false);

  const userId = parseInt(props.match?.params?.userId) || 0;

  useEffect(() => {
    LoadUserData();
  }, []);

  async function LoadUserData() {
    try {
      setLoading(true);
      const result = await api.get(`users/${userId}`);
      console.log(result);
      if (result.data.success) {
        const userData = result.data.userData;
        setName(userData.name);
        setEmail(userData.email);
        setPhone(userData.phone);
        setCPF(CPFMask(userData.cpf));
        setRG(userData.rg);
        setAddress(userData.address);
        setCep(userData.zipCode);
        setAddressNumber(userData.addressNumber);
        setCity(userData.city);
        setState(userData.state);
        setNeighborhood(userData.neighborhood); // Carrega o bairro
      } else {
        setErrorMessage(
          result.data?.message || "Não foi possível buscar dados do usuário"
        );
        console.error("Não pode pegar os dados do usuário: ", result.data);
      }
    } catch (error: any) {
      console.error("Erro pegando os dados do usuário: ", error);
      setErrorMessage(
        error.response?.data?.message ||
        "Não foi possível buscar os dados do usuário"
      );
    } finally {
      setLoading(false);
    }
  }

  function validateFields() {
    const requiredFields = {
      Nome: name,
      Email: email,
      Telefone: phone,
      CPF: cpf,
      Endereço: address,
      CEP: cep,
      Número: addressNumber,
      Cidade: city,
      Estado: state,
      Bairro: neighborhood, // Adiciona bairro como campo obrigatório
    };

    for (const [fieldName, value] of Object.entries(requiredFields)) {
      if (!value || value.trim() === "") {
        return `O campo ${fieldName} é obrigatório`;
      }
    }
    return null;
  }

  async function OnSubmit() {
    const validationError = validateFields();
    if (validationError) {
      setErrorMessage(validationError);
      return;
    }
    try {
      setLoading(true);
      const data = {
        name,
        email,
        phone,
        cpf,
        rg,
        address,
        cep,
        addressNumber,
        city,
        state,
        neighborhood, // Adiciona bairro nos dados enviados
      };
      const result = await api.put(`users/${userId}`, data);

      if (result.data.success) setShowSuccessPopup(true);
      else {
        setErrorMessage(
          result?.data?.message || "Não foi possível atualizar dados do usuário"
        );
        console.error(
          "Não foi possível atualizar dados do usuário, erro: ",
          result.data
        );
      }
    } catch (error: any) {
      console.error(error);
      setErrorMessage(
        error?.response?.data?.message ||
        "Não foi possível atualizar dados do usuário"
      );
    } finally {
      setLoading(false);
    }
  }

  function goBack() {
    props.history.goBack();
  }

  const disabled = loading;

  function ShowSuccessPopup() {
    return (
      <InfoModal
        show={showSuccessPopup}
        onHide={() => setShowSuccessPopup(false)}
        loading={false}
        title="Usuário editado com sucesso!"
        body="Suas edições do usuário foram salvas com sucesso"
        primaryText="OK"
        primaryOnClick={() => setShowSuccessPopup(false)}
        primaryDisabled={false}
      />
    );
  }

  return (
    <Style>
      <PageTitle title="Editar Usuário" />
      {ShowSuccessPopup()}
      <div className="productDetails">
        <div>
          <button onClick={() => goBack()} className="btn btn-secondary">
            Voltar
          </button>
        </div>
        <Spinner spinning={loading} />
        {errorMessage !== "" && (
          <p className="alert alert-error">Erro: {errorMessage}</p>
        )}
        <main>
          <div className="panel">
            <form
              className="main-form"
              onSubmit={(e) => {
                e.preventDefault();
                OnSubmit();
              }}
            >
              <div>
                <h2>Editar Usuário</h2>
              </div>
              <div>
                <label>Nome:</label>
                <input
                  autoComplete="user-name"
                  disabled={disabled}
                  value={name || ""}
                  onChange={(e) => setName(e.target.value)}
                />
              </div>

              <div>
                <label>Email:</label>
                <input
                  autoComplete="user-email"
                  disabled={disabled}
                  value={email || ""}
                  onChange={(e) => setEmail(e.target.value)}
                />
              </div>

              <div>
                <label>Telefone:</label>
                <input
                  autoComplete="user-phone"
                  disabled={disabled}
                  value={phone || ""}
                  onChange={(e) => setPhone(e.target.value)}
                />
              </div>

              <div>
                <label>CPF:</label>
                <input
                  autoComplete="user-cpf"
                  disabled={disabled}
                  maxLength={14}
                  value={cpf || ""}
                  onChange={(e) => setCPF(CPFMask(e.target.value))}
                />
              </div>

              <div>
                <label>RG:</label>
                <input
                  autoComplete="user-rg"
                  disabled={disabled}
                  maxLength={14}
                  value={rg || ""}
                  onChange={(e) => setRG(e.target.value)}
                />
              </div>

              <div>
                <label>Endereço:</label>
                <input
                  autoComplete="street-address"
                  disabled={disabled}
                  value={address || ""}
                  onChange={(e) => setAddress(e.target.value)}
                />
              </div>
              <div>
                <label>CEP:</label>
                <input
                  autoComplete="postal-code"
                  disabled={disabled}
                  value={cep || ""}
                  onChange={(e) => setCep(e.target.value)}
                />
              </div>
              <div>
                <label>Número:</label>
                <input
                  autoComplete="off"
                  disabled={disabled}
                  value={addressNumber || ""}
                  onChange={(e) => setAddressNumber(e.target.value)}
                />
              </div>
              <div>
                <label>Cidade:</label>
                <input
                  autoComplete="address-level2"
                  disabled={disabled}
                  value={city || ""}
                  onChange={(e) => setCity(e.target.value)}
                />
              </div>
              <div>
                <label>Estado:</label>
                <input
                  autoComplete="address-level1"
                  disabled={disabled}
                  value={state || ""}
                  onChange={(e) => setState(e.target.value)}
                />
              </div>
              <div>
                <label>Bairro:</label>
                <input
                  autoComplete="address-level3"
                  disabled={disabled}
                  value={neighborhood || ""}
                  onChange={(e) => setNeighborhood(e.target.value)}
                />
              </div>
              <button
                className="btn btn-success btn-lg mt-4"
                type="button"
                disabled={disabled}
                onClick={(e) => {
                  e.preventDefault();
                  OnSubmit();
                }}
              >
                Editar
              </button>
            </form>
          </div>
        </main>
      </div>
    </Style>
  );
}
